import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'lfw-toolbar-button',
  templateUrl: './app-toolbar-button.component.html',
  styleUrl: './app-toolbar-button.component.scss',
  imports: [MatIcon, MatTooltip]
})
export class AppToolbarButtonComponent {
  readonly label = input.required<string>();
  readonly icon = input.required<string>();
  readonly tooltip = input<string>();
  readonly disabled = input(false);
}
